import { format } from "date-fns";

export const DEFAULT_PRESCRIPTION_VALUES = {
  qty: 1,
  diagnosis_code: [],
  is_specialty_pharmacy_only: false,
  drug_name: "StimRouter Neuromodulation System",
  scheduled_date_of_service: "",
  written_date: format(new Date(), 'MM/dd/yyyy'),
  direction: "",
  note: "",
}
